module.exports = __webpack_public_path__ + "img/9.b639cf8b.png";